import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "totalCount", "selectedCount", "bulkActionContainer"]
  static values = {
    totalCount: Number
  }

  connect() {
    this.selectedItems = new Set();
    this.allSelected = false;

    this.boundUpdateCheckboxes = this.updateCheckboxes.bind(this);

    document.addEventListener("turbo:load", this.boundUpdateCheckboxes);

    this.updateCheckboxes();
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundUpdateCheckboxes);
  }

  updateCheckboxes() {
    if (this.selectedItems.size > 0 || this.allSelected) {
      this.totalCountTarget.classList.add("hidden");
      this.bulkActionContainerTarget.classList.remove("hidden");
      this.selectedCountTarget.textContent = this.allSelected ? (this.totalCountValue - this.selectedItems.size) + " selected" : this.selectedItems.size + " selected";
    } else {
      this.totalCountTarget.classList.remove("hidden");
      this.bulkActionContainerTarget.classList.add("hidden");
    }

    this.checkboxTargets.forEach(checkbox => {
      if (this.allSelected) {
        checkbox.checked = !this.selectedItems.has(checkbox.dataset["itemIdParam"]);
      } else {
        checkbox.checked = this.selectedItems.has(checkbox.dataset["itemIdParam"]);
      }
    });
  }

  toggle(event) {
    const itemId = event.target.dataset["itemIdParam"];
    if (this.selectedItems.has(itemId)) {
      this.selectedItems.delete(itemId);
    } else {
      this.selectedItems.add(itemId);
    }
    this.updateCheckboxes();
  }

  toggleSelectAll(event) {
    this.selectedItems.clear();
    this.allSelected = !this.allSelected;
    this.updateCheckboxes();
  }

  bulkAction(event) {
    event.preventDefault();
    event.stopPropagation();

    const url = new URL("/dashboard/shared/background_actions/new", window.location.origin);

    url.searchParams.set("background_action[type]", event.params.action);

    if (this.allSelected) {
      url.searchParams.set("background_action[include_ids]", "all");
      url.searchParams.set("background_action[exclude_ids]", Array.from(this.selectedItems).join(","));
    } else {
      url.searchParams.set("background_action[include_ids]", Array.from(this.selectedItems).join(","));
    }

    window.renderModal(url.toString());
  }
}